// material ui
import { Stack, Typography, CircularProgress } from "@mui/material";

type TextInformationProps = {
    label: string,
    data: string,
    truncate?: boolean,
    whiteSpace?: "normal" | "pre" | "nowrap" | "pre-wrap" | "pre-line" | "break-spaces",
    strong?: boolean,
    loading?: boolean,
    helperText?: string,
    loadingHelperText?: boolean,
    sx?: {},
}

const TextInformation = ({ label, data, truncate, whiteSpace, strong, loading, helperText, loadingHelperText, sx }: TextInformationProps) => {
    // Determine if the `word-break` style should be applied
    let shouldBreakWords = false;
    try {
        shouldBreakWords = data.length > 15 && (!data.includes(' ') || data.split(' ').some(word => (word && word.length > 20)));
    } catch (error) {
        console.warn(error, { data });
    }

    let txt = "-";
    if (data !== "") txt = data;
    let emptyLabel = false;
    if (label === "") emptyLabel = true;

    return (
        <Stack spacing={0.2} sx={sx}>
            <Typography sx={{ height: emptyLabel ? "22px" : "initial" }} color="secondary">{label}</Typography>
            {!loading && <Typography
                noWrap={truncate}
                sx={{
                    whiteSpace: whiteSpace ? whiteSpace : truncate ? 'nowrap' : 'normal',
                    wordBreak: shouldBreakWords ? 'break-all' : 'normal',
                    fontWeight: strong ? "500" : "initial"
                }}
            >
                {txt}
            </Typography>}
            {loading && <CircularProgress size={16} color="secondary" />}
            {!loadingHelperText && helperText && (
                <Typography variant="caption" color="text.secondary">
                    {helperText}
                </Typography>
            )}
            {loadingHelperText && <CircularProgress size={14} color="secondary" />}
        </Stack>
    )
}

export default TextInformation;
